/**
 * CoLab Search Modal Module
 * Модальне вікно пошуку з keyboard shortcuts
 */

let modal = null;
let input = null;
let form = null;
let overlay = null;

function init() {
    modal = document.getElementById('searchModal');
    if (!modal) return;

    input = modal.querySelector('.search-modal__input');
    form = modal.querySelector('.search-modal__form');
    overlay = modal.querySelector('.search-modal__overlay');

    bindEvents();
}

function bindEvents() {
    // Open buttons
    const openBtns = document.querySelectorAll('[data-search-toggle]');
    openBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            open();
        });
    });

    // Close buttons
    const closeBtns = document.querySelectorAll('[data-search-close]');
    closeBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            close();
        });
    });

    // Close on overlay click
    if (overlay) {
        overlay.addEventListener('click', function() {
            close();
        });
    }

    // Keyboard shortcuts
    document.addEventListener('keydown', function(e) {
        // Close on Escape
        if (e.key === 'Escape' && isOpen()) {
            close();
        }

        // Toggle on Ctrl/Cmd + K
        if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
            e.preventDefault();
            toggle();
        }
    });

    // Form submit validation
    if (form) {
        form.addEventListener('submit', function(e) {
            if (!input.value.trim()) {
                e.preventDefault();
                input.focus();
            }
        });
    }

    // Popular tags
    const tags = modal.querySelectorAll('.search-modal__tag');
    tags.forEach(function(tag) {
        tag.addEventListener('click', function(e) {
            e.preventDefault();
            if (input) {
                input.value = this.textContent;
                input.focus();
            }
        });
    });
}

function open() {
    modal.classList.add('is-open');
    document.body.classList.add('search-open');

    // Focus input after animation
    setTimeout(function() {
        if (input) input.focus();
    }, 100);

    // Trigger event
    document.dispatchEvent(new CustomEvent('searchOpen'));
}

function close() {
    modal.classList.remove('is-open');
    document.body.classList.remove('search-open');

    // Clear input
    if (input) input.value = '';

    // Trigger event
    document.dispatchEvent(new CustomEvent('searchClose'));
}

function toggle() {
    if (isOpen()) {
        close();
    } else {
        open();
    }
}

function isOpen() {
    return modal.classList.contains('is-open');
}

// Public method for external search
function search(query) {
    if (input) {
        input.value = query;
    }
    if (form) {
        form.submit();
    }
}

export const Search = {
    init,
    search
};
